import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgQuickPickupOutline24 = function SvgQuickPickupOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 23v.55h.561l-.011-.561zm-19.556 0h-.55v.55h.55zm0-18.48v-.55h-.55v.55zm19.18 0 .55-.011-.011-.539h-.54zM20.806 7.16v.55h1.1v-.55zm7.277 0v.55h1.1v-.55zM10.788 6.055a.55.55 0 1 0 0-1.1zM1 4.955a.55.55 0 1 0 0 1.1zm9.788 3.74a.55.55 0 1 0 0-1.1zm-4.785-1.1a.55.55 0 1 0 0 1.1zm4.785 4.18a.55.55 0 0 0 0-1.1zm-2.057-1.1a.55.55 0 1 0 0 1.1zM35 22.45H15.444v1.1H35zM15.994 23V4.52h-1.1V23zm-.55-17.93h19.18v-1.1h-19.18zm18.63-.539.376 18.48 1.1-.022-.376-18.48zM21.906 7.16V4.08h-1.1v3.08zm0-3.08c0-1.315 1.294-2.53 3.089-2.53V.45c-2.224 0-4.189 1.543-4.189 3.63zm3.089-2.53c1.794 0 3.088 1.215 3.088 2.53h1.1c0-2.087-1.965-3.63-4.188-3.63zm3.088 2.53v3.08h1.1V4.08zm-17.295.875H1v1.1h9.788zm0 2.64H6.003v1.1h4.785zm0 3.08H8.73v1.1h2.057z",
    fill: "currentColor"
  })));
};

var QuickPickupOutline24Svg = SvgQuickPickupOutline24;

export { QuickPickupOutline24Svg as default };
//# sourceMappingURL=QuickPickupOutline24.svg.js.map
